import { Box, Skeleton, Stack } from '@mui/material';

export const MplInvoiceListItemSkeleton = () => {
	return (
		<Stack direction="row" alignItems="center" gap={2} padding={1}>
			<Skeleton variant="rounded" width={24} height={24} animation="pulse" />
			<Skeleton variant="rounded" width={180} height={18} animation="pulse" />
			<Box flex={1} />
			<Skeleton variant="rounded" width={24} height={24} animation="pulse" />
		</Stack>
	);
};
